import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { callGetPayPalClientIdApi } from 'requests/RequestPayment';
import { HttpStatus } from 'consts/HttpStatus';

export const usePayPalClientId = () => {
	const history = useHistory();
	const [clientId, setClientId] = useState('');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const execute = async () => {
			const result = await callGetPayPalClientIdApi();
			if (result.status !== HttpStatus.OK || !result.data || !result.data.paypal_client_id) {
				history.push(RoutePath.ERROR);
				return;
			}
			setClientId(result.data.paypal_client_id);
			setLoading(false);
		};
		execute();
	}, []);

	return {
		clientId,
		loading,
	};
};
